import { NavigationDataResponse } from '@/api/navigationApi/types.gen'
import { useMantineColorScheme } from '@mantine/core'
import { useEffect, useRef } from 'react'
import { LngLatLike, MapRef } from 'react-map-gl/mapbox'

export const useNavigationMapUpdate = ({
  data,
  mapRef,
  zoom = 17,
}: {
  data: NavigationDataResponse | undefined
  mapRef: MapRef | undefined
  zoom?: number
}) => {
  const { setColorScheme, colorScheme } = useMantineColorScheme()
  const isFirstUpdateRef = useRef(true)

  useEffect(() => {
    if (!data?.patrol_vehicle.position || !mapRef) return

    const {
      position: { latitude, longitude },
      azimuth,
    } = data.patrol_vehicle
    const map = mapRef.getMap()

    const { camera_mode } = data
    if (camera_mode === 'night' && colorScheme !== 'dark') setColorScheme('dark')
    else if (camera_mode === 'day' && colorScheme !== 'light') setColorScheme('light')

    if (!latitude || !longitude || (latitude === 0 && longitude === 0)) return

    map.stop()

    const center: LngLatLike = [longitude, latitude]

    if (isFirstUpdateRef.current) {
      map.jumpTo({
        center,
        bearing: azimuth ?? 0,
        zoom,
      })
      isFirstUpdateRef.current = false
      return
    }

    map.easeTo({
      center,
      bearing: azimuth ?? 0,
      zoom,
      duration: 800,
      easing: t => t,
      essential: true,
      animate: true,
    })
  }, [data, mapRef, zoom, colorScheme, setColorScheme])
}
